<template>
    <div v-if="isVisible" 
         class="lw-cols main align-items-stretch one-row one-row-tl one-row-tp one-row-sl multiple-rows-sp 
                js-same-content-wrapper lw-dark-bg lw-padding-normal">
        
        <div class="col flex-item flexible span_4_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl 
                    span_12_of_12-sp mb-2rem-sp no-padding">
            
            <div class="learnworlds-image no-margin-bottom learnworlds-bg-default stretched-bg learnworlds-framed-image 
                        learnworlds-element rectangle learnworlds-frame-size-full" 
                 :style="imageStyles">
                
                <div class="lw-tags absolute tl">
                    <div v-if="productDetails.expires" 
                         class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element 
                                learnworlds-main-text-tiny">                        
                        <span>{{ i18n.get('course.access_for') }}</span> 
                        <span>{{ productDetails.expires }} {{ i18n.get(`common.${productDetails.expiresType}`) }}</span>
                    </div>
                    
                    <div v-if="productDetails.trial_period_days" 
                         class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element 
                                learnworlds-main-text-tiny">                        
                        {{ productDetails.trial_period_days }} - 
                        {{ i18n.get(productDetails.trial_period_days > 1 ? 'common.days': 'common.day' ) }} 
                        {{ i18n.get('common.trial') }}
                    </div>
                </div>
            </div>
            
            <div class="with-flexible-parts justify-content-space-between align-items-center mt-2rem">
                <div>
                    <p v-if="productDetails.discountFlag" 
                       class="learnworlds-main-text learnworlds-element lw-text-color-fadeout50 
                       learnworlds-main-text-small v-middle no-margin-bottom">
                        {{ i18n.get('payments.initial_price') }}
                    </p>
                    
                    <p class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal">
                        <strong>{{ i18n.get('payments.final_price') }}</strong>
                    </p>
                </div>
                
                <div>
                    <p v-if="productDetails.discountFlag" 
                       class="learnworlds-main-text learnworlds-element lw-text-color-fadeout50 
                       learnworlds-main-text-small lw-deleted-price v-middle no-margin-bottom">
                        {{ formatPrice(productInitialPrice) }}
                    </p>
                    
                    <p class="learnworlds-main-text learnworlds-element learnworlds-main-text-normal">
                        <strong>
                            {{ formatPrice(productFinalPrice) }}  
                            <span v-if="hasInterval"> / {{ subscriptionIntervalText }} </span>
                        </strong>
                    </p>
                </div>
            </div>
        </div>
        
        <div class="col flex-item flexible with-flexible-parts span_8_of_12 span_8_of_12-tl 
                    span_8_of_12-tp span_8_of_12-sl span_12_of_12-sp no-padding">
            
            <div class="flexible-part js-lw-flexible-wrapper no-padding">
                <div class="flexible-part">
                    <div class="learnworlds-overline-text learnworlds-element">
                        {{ orderDetailsLabel }}
                    </div>
                    
                    <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal mt-0 
                                lw-cursor-pointer" 
                        @click="navigateToProductPage">
                        {{ productDetails.title }}
                    </h3>
                    
                    <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                        {{ productDetails.description }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapGetters} from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";    
    export default {
        name: "PaymentProductDetailsComponent",
        mixins: [
            
        ],
        data () {
            return {
                componentType: "PaymentProductDetails",
                rendersWithVue: true                
            }
        },
        computed:{
            ...mapState([
                'clientURL',
            ]),
            getDefaultDataStructure () {
                return {
                  componentType: this.componentType,
                  componentId: this.componentId,                
                  visibilityStatus: true,
                  itemVisibilitySettings: null
                }
            },
            contextWrapper () {
                return this.hasContext("payment-manager") 
                    ? this.findNodeState(this.hasContext("payment-manager")[0].id) 
                    : null;
            },
            product(){ 
                if(!this.contextWrapper){
                    return {
                        id: null,
                        type: null,
                        coupon: null
                    };
                }     
                
                return this.contextWrapper.getProduct;
            },
            productDetails(){
                if(!this.contextWrapper){
                    return {};
                }
                
                return this.contextWrapper.productDetails;
            },                        
            productInitialPrice(){
                return this.productDetails.price;
            },
            productFinalPrice(){
                return (this.productDetails.discountFlag)
                    ? this.productDetails.discountPrice 
                    : this.productDetails.price;    
            },
            productUrl() {
                let url = `${this.clientURL}/`;
                
                switch (this.product.type) {
                    case 'course': 
                        url += `course?courseid`;
                        break;
                    case 'bundle':
                        url += `bundles?bundle_id`;
                        break;
                    case 'subscription':
                        url += `subscriptions?id`;
                        break;
                    default:
                        return
                }
                
                url += `=${this.productDetails.titleId}`;
                
                return url;
            },
            hasInterval(){
                 return this.productDetails.interval_type;
            },
            subscriptionIntervalText(){
                if(this.productDetails.interval > 1){
                    return this.productDetails.interval + ' ' + this.i18n.get('common.' + this.productDetails.interval_type);
                }
                return this.i18n.get('common.' + this.productDetails.interval_type);
            },
            imageStyles(){                
                return (this.productDetails.image)
                    ? {backgroundImage: 'url(' + this.productDetails.image + ')'} 
                    : {};
            },
            numberOfCourses() {
                if(!this.contextWrapper){
                    return '';
                }
                
                if (this.productDetails?.products?.courses?.length) {
                    return this.productDetails.products.courses.length;
                }
                
                return '';
            },
            subtitle() {
                let productTypeTranslation = this.productTypeTranslation;
                
                if (this.numberOfCourses) {
                    return `${productTypeTranslation} (${this.numberOfCourses} ${this.i18n.get('common.courses')})`;
                }

                return productTypeTranslation;
            },
            productTypeTranslation() {
                switch (this.product.type) {
                    case 'course':
                        return this.i18n.get('common.course');
                    case 'subscription':
                        return this.i18n.get('common.single_subscription');
                    case 'bundle':
                        return this.i18n.get('common.bundle');    
                    default:
                        return this.product.type;
                }
            },
            orderDetailsLabel() {
                return `${this.i18n.get('payments.order_details')}: ${this.subtitle}`;
            },

            getVisibilityStatus() {
                return this.myData.visibilityStatus;
            },
            isVisible() {
                return this.getVisibilityStatus;
            },
        },
    
        methods: {           
            formatPrice(price){
                const currency  = this.productDetails.currency;
                return `${currency}${price}`;
            },
            navigateToProductPage() {}
        }
    }
</script>
